import { LogoWrapper } from '../logo-wrapper';
import React from 'react';
import styled from 'styled-components';
import { useLayoutContext } from './layout';
import { media } from '../../hooks/use-responsive-v2.hook';
import { getColor } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLogoWrapper = styled.div.withConfig({
  displayName: "layout-logo__StyledLogoWrapper",
  componentId: "sc-1xji5gs-0"
})(["height:", ";min-height:", ";display:flex;align-items:center;justify-content:", ";padding:", ";background:#ffffff;border-bottom:1px solid rgba(0,0,0,0.06);&:focus-visible{outline:2px solid ", ";outline-offset:-2px;}", "{", "}", ""], function (props) {
  return props.$height;
}, function (props) {
  return props.$height;
}, function (props) {
  return props.$collapsed ? 'center' : 'flex-start';
}, function (props) {
  return props.$collapsed ? '0' : '0 24px';
}, getColor('fillIntActive'), media.mobile, function (props) {
  return props.$compactMobile && 'padding: 0; justify-content: center;';
}, function (p) {
  return p.$clickable && "\n    cursor: pointer;\n    transition: opacity 0.3s;\n    &:hover {\n      opacity: 0.8;\n    }\n  ";
});
var DefaultLogoImage = styled.img.withConfig({
  displayName: "layout-logo__DefaultLogoImage",
  componentId: "sc-1xji5gs-1"
})(["height:30px;"]);
export var LayoutLogo = function LayoutLogo(_ref) {
  var subTitle = _ref.subTitle,
      logoSrc = _ref.logoSrc,
      logoTitleSrc = _ref.logoTitleSrc,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Digibricks' : _ref$title,
      _ref$logoWidth = _ref.logoWidth,
      logoWidth = _ref$logoWidth === void 0 ? 40 : _ref$logoWidth,
      _ref$logoHeight = _ref.logoHeight,
      logoHeight = _ref$logoHeight === void 0 ? 40 : _ref$logoHeight,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '60px' : _ref$height,
      children = _ref.children,
      onLogoClick = _ref.onLogoClick,
      forceCollapsed = _ref.forceCollapsed;

  var _useLayoutContext = useLayoutContext(),
      layoutCollapsed = _useLayoutContext.collapsed,
      mobileFullWidth = _useLayoutContext.mobileFullWidth;

  var collapsed = forceCollapsed !== null && forceCollapsed !== void 0 ? forceCollapsed : layoutCollapsed;
  var hasLogoProps = subTitle && logoSrc && logoTitleSrc;
  var content = children !== undefined ? children : hasLogoProps ? /*#__PURE__*/_jsx(LogoWrapper, {
    subTitle: subTitle,
    logoSrc: logoSrc,
    logoTitleSrc: logoTitleSrc,
    title: title,
    logoWidth: logoWidth,
    logoHeight: logoHeight,
    collapsed: collapsed,
    compactOnMobile: mobileFullWidth
  }) : /*#__PURE__*/_jsx(DefaultLogoImage, {
    src: "/icons/digi-logo.svg",
    alt: "logo"
  });
  return /*#__PURE__*/_jsx(StyledLogoWrapper, {
    $height: height,
    $clickable: !!onLogoClick,
    $collapsed: collapsed,
    $compactMobile: mobileFullWidth,
    onClick: onLogoClick,
    role: onLogoClick ? 'button' : undefined,
    tabIndex: onLogoClick ? 0 : undefined,
    onKeyDown: onLogoClick ? function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      onLogoClick();
    } : undefined,
    children: content
  });
};
LayoutLogo.displayName = 'LayoutIcon';